export const CreatecaseTemplateFormSteps = [
  {
    target: "#Header",
    content: "Edit template name and choose a practice area",
  },
  {
    target: "#another-element",
    content: "Drag fields from here to build your form",
  },
  {
    target: "#fine",
    content: "Switch between different form views",
  },
  {
    target: "#preview-save-button",
    content: "Preview the template and save your changes",
  },
];
